{
  "back": "Retour",
  "share": "Partager",
  "watchVideo": "Regarder la vidéo",
  "notFoundTitle": "Prédication introuvable",
  "notFoundDescription": "Nous n'avons pas trouvé cette prédication."
}
